
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[...destination]",
      function () {
        return require("private-next-pages/destinations/[...destination].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/[...destination]"])
      });
    }
  